import { createApi } from '@reduxjs/toolkit/query/react';
import { pensionBaseQuery } from '../../lib/axiosBaseQuery';

export const employerApi = createApi({
  reducerPath: 'employerApi',
  baseQuery: pensionBaseQuery,
  tagTypes: ['Employers'],
  endpoints: (builder) => ({
    getEmployers: builder.query<any, void>({
      query: () => ({
        url: `api/v1/manage/employers/list`,
        method: 'GET',
      }),
      providesTags: ['Employers'],
    }),
    createEmployer: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: `api/v1/manage/employers/create`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Employers'],
    }),
    updateEmployer: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: `api/v1/manage/employers/update`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['Employers'],
    }),
    deleteEmployer: builder.mutation<any, string>({
      query: (id) => ({
        url: `api/v1/manage/employers/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Employers'],
    }),
  }),
});

export const {
  useGetEmployersQuery,
  useCreateEmployerMutation,
  useUpdateEmployerMutation,
  useDeleteEmployerMutation,
} = employerApi;
